// import { useState, useEffect } from "react";
// import { RxCross2 } from "react-icons/rx";
// import "./index.css";

// const DelayedFormPopup = () => {
//   const [showPopup, setShowPopup] = useState(false);

//   useEffect(() => {
//     const timer = setTimeout(() => {
//       setShowPopup(true);
//     }, 1000); // 15 seconds = 15000 ms

//     return () => clearTimeout(timer); // Clean up on unmount
//   }, []);

//   const handleClose = () => setShowPopup(false);

//   return (
//     <>
//       {showPopup && (
//         <div className="popup-overlay">
//           <div className="popup-form">
//             <div className="offer-container">
//               <button onClick={handleClose} className="close-btn me-5 mt-4">
//                 <RxCross2 />
//               </button>

//               <p className="date">IBIX Scholarship</p>
//               <div>
//                 <img
//                   src="https://iqteche.in/static/media/wl_client_images/33abc127ad7c4e16987e7e7feaa79262.png"
//                   alt="NRI Scholarships"
//                   className="scholarship-image"
//                 />
//               </div>
//               <h2 className="title">
//                 <span className="flag-color-1">IBIX</span> <br />{" "}
//                 <span className="flag-color-2">NRI Scholarship's</span>
//                 <br />
//                 <span className="flag-color-3">Get Upto 15,000/- </span>
//               </h2>
//               <p className="limited-seats">
//                 Enroll Today Limited Seats Available
//               </p>

//               <p className="footer-text">
//                 Learn Today & Lead Tomorrow with high paid tech Jobs.
//               </p>
//             </div>
//           </div>
//         </div>
//       )}
//     </>
//   );
// };

// export default DelayedFormPopup;

// New pop-up model
import { useState, useEffect } from "react";
import {
  RxCross2,
  RxCheckCircled,
  RxArrowRight,
  RxLightningBolt,
} from "react-icons/rx";
import { FiUser, FiPhone, FiMail, FiAward } from "react-icons/fi";

import "./index.css";

const GOOGLE_SCRIPT_URL =
  "https://script.google.com/macros/s/AKfycbyi37mPdUKH3sYCSgQNS6WX4qcuv0h-zmS7J0y4tCo_I8-qB-cT-35_lCf43PBdn_pA/exec";

const DelayedFormPopup = () => {
  const [showPopup, setShowPopup] = useState(false);
  const [showForm, setShowForm] = useState(false);

  const [formData, setFormData] = useState({
    name: "",
    mobile: "",
    email: "",
  });

  const [isConfirmed, setIsConfirmed] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [error, setError] = useState("");

  // Show popup after 40 seconds
  useEffect(() => {
    const timer = setTimeout(() => {
      setShowPopup(true);
    }, 10000);

    return () => clearTimeout(timer);
  }, []);

  const handleClose = () => {
    setShowPopup(false);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    setError("");
  };

  const handleRegister = () => {
    setShowForm(true);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!isConfirmed) {
      setError("Please confirm that the details provided are correct.");
      return;
    }

    setIsSubmitting(true);
    setError("");

    try {
      await fetch(
        "https://script.google.com/macros/s/AKfycbyi37mPdUKH3sYCSgQNS6WX4qcuv0h-zmS7J0y4tCo_I8-qB-cT-35_lCf43PBdn_pA/exec",
        {
          method: "POST",
          mode: "no-cors",
          headers: {
            "Content-Type": "text/plain;charset=utf-8",
          },
          body: JSON.stringify({
            name: formData.name,
            mobile: formData.mobile,
            email: formData.email,
            source: "7 Days Free Trial Popup",
            page: window.location.pathname,
          }),
        },
      );

      // Submission completed
      setIsSubmitted(true);

      setFormData({
        name: "",
        mobile: "",
        email: "",
      });

      setIsConfirmed(false);
    } catch (error) {
      console.error("Submission Error:", error);

      setError("Unable to submit your details. Please try again.");
    } finally {
      setIsSubmitting(false);
    }
  };

  if (!showPopup) {
    return null;
  }

  return (
    <div className="trial-popup-overlay">
      <div className="trial-popup">
        {/* Close Button */}
        <button
          className="trial-close-btn"
          onClick={handleClose}
          aria-label="Close popup"
        >
          <RxCross2 />
        </button>

        {!showForm && !isSubmitted && (
          <div className="trial-offer">
            {/* Left / Main Content */}
            <div className="trial-content">
              <p className="trial-small-title">IBIX QODIFY TECHNOLOGIES</p>

              <h2>
                Register for
                <span> 7 Days FREE Trial</span>
              </h2>

              <p className="trial-description">
                Experience our learning environment, understand our training
                methodology and kick-start your technology career with
                confidence.
              </p>

              <div className="trial-highlights">
                <div>
                  <RxCheckCircled />
                  <span>7 Days Free Access</span>
                </div>

                <div>
                  <RxCheckCircled />
                  <span>Career Guidance</span>
                </div>

                <div>
                  <RxCheckCircled />
                  <span>Industry-Oriented Learning</span>
                </div>
              </div>

              <button className="trial-register-btn" onClick={handleRegister}>
                Register for FREE Trial
                <RxArrowRight />
              </button>

              <p className="trial-note">
                No payment required • Limited registrations
              </p>
            </div>

            {/* Right Image */}
            <div className="trial-image-section">
              <div className="image-glow"></div>

              <img
                src="https://iqteche.in/static/media/wl_client_images/33abc127ad7c4e16987e7e7feaa79262.png"
                alt="IBIX 7 Days Free Trial"
                className="trial-image"
              />

              <div className="floating-card">
                <RxLightningBolt />
                <div>
                  <strong>7 Days</strong>
                  <small>FREE TRIAL</small>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* FORM */}
        {showForm && !isSubmitted && (
          <div className="trial-form-wrapper">
            {" "}
            <div className="form-header">
              {" "}
              <h2>Start Your Free Trial</h2>{" "}
              <p>
                Fill in your details and our Career Expert will contact you.
              </p>{" "}
            </div>{" "}
            <form onSubmit={handleSubmit}>
              {" "}
              {/* Name */}{" "}
              <div className="input-group">
                {" "}
                <label htmlFor="name">Student Name</label>{" "}
                <div className="input-wrapper">
                  {" "}
                  <span className="input-icon">
                    {" "}
                    <FiUser />{" "}
                  </span>{" "}
                  <input
                    id="name"
                    type="text"
                    name="name"
                    placeholder="Enter your full name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                  />{" "}
                </div>{" "}
              </div>{" "}
              {/* Mobile */}{" "}
              <div className="input-group">
                {" "}
                <label htmlFor="mobile">Mobile Number</label>{" "}
                <div className="input-wrapper">
                  {" "}
                  <span className="input-icon">
                    {" "}
                    <FiPhone />{" "}
                  </span>{" "}
                  <input
                    id="mobile"
                    type="tel"
                    name="mobile"
                    placeholder="Enter 10-digit mobile number"
                    value={formData.mobile}
                    onChange={handleChange}
                    pattern="[0-9]{10}"
                    maxLength="10"
                    inputMode="numeric"
                    required
                  />{" "}
                </div>{" "}
              </div>{" "}
              {/* Email */}{" "}
              <div className="input-group">
                {" "}
                <label htmlFor="email">Email Address</label>{" "}
                <div className="input-wrapper">
                  {" "}
                  <span className="input-icon">
                    {" "}
                    <FiMail />{" "}
                  </span>{" "}
                  <input
                    id="email"
                    type="email"
                    name="email"
                    placeholder="Enter your email address"
                    value={formData.email}
                    onChange={handleChange}
                    required
                  />{" "}
                </div>{" "}
              </div>{" "}
              {/* Confirmation */}{" "}
              <label className="confirmation-box">
                {" "}
                <input
                  type="checkbox"
                  checked={isConfirmed}
                  onChange={(e) => setIsConfirmed(e.target.checked)}
                />{" "}
                <span className="custom-checkbox">
                  {" "}
                  {isConfirmed && <RxCheckCircled />}{" "}
                </span>{" "}
                <span>
                  {" "}
                  I confirm that the details provided above are correct.{" "}
                </span>{" "}
              </label>{" "}
              {/* Error */} {error && <p className="form-error"> {error} </p>}{" "}
              {/* Submit */}{" "}
              <button
                type="submit"
                className={`submit-trial-btn ${isConfirmed ? "active" : ""}`}
                disabled={!isConfirmed || isSubmitting}
              >
                {" "}
                {isSubmitting
                  ? "Submitting..."
                  : "Submit & Start My Free Trial"}{" "}
                {!isSubmitting && <RxArrowRight />}{" "}
              </button>{" "}
              {/* Back */}{" "}
              <button
                type="button"
                className="back-btn"
                onClick={() => setShowForm(false)}
              >
                {" "}
                ← Back to Offer{" "}
              </button>{" "}
            </form>{" "}
          </div>
        )}

        {/* SUCCESS */}
        {isSubmitted && (
          <div className="success-wrapper">
            <div className="success-icon">
              <RxCheckCircled />
            </div>

            <div className="success-badge">REGISTRATION SUCCESSFUL</div>

            <p>
              Thank you for registering for the
              <strong> 7 Days Free Trial.</strong>
            </p>

            <div className="success-message">
              <FiAward />

              <div>
                <strong>Our Career Counsellor Expert will contact you</strong>
              </div>
            </div>

            <button className="success-close-btn" onClick={handleClose}>
              Continue Exploring IBIX
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default DelayedFormPopup;
